<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 20 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="fill" height="2" rx="1" width="2"/>
    <rect :fill="fill" height="2" rx="1" width="2" y="7"/>
    <rect :fill="fill" height="2" rx="1" width="2" y="14"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="18"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="18" y="7"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="18" y="14"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="6"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="6" y="7"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="6" y="14"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="12"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="12" y="7"/>
    <rect :fill="fill" height="2" rx="1" width="2" x="12" y="14"/>
  </svg>
</template>

<script>
export default {
  name: 'Grid',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
